import { makeStyles } from '@mui/styles';
import Table from 'apollo-react/components/Table';
import React from 'react';

import { useTranslation } from '../../../custom-hooks/useTranslation';
import StatusCell from '../../CommonTableCells/StatusCell';

const useStyles = makeStyles({
  statusTable: {
    border: 'solid 1px #e9e9e9',
    boxShadow: '0 4px 16px 0 rgb(0 0 0 / 4%)',
  },
});

const columns = [
  {
    header: 'Code',
    accessor: 'EntityCode',
  },
  {
    header: 'Message',
    accessor: 'Message',
  },
  {
    header: 'Status',
    accessor: 'StatusCode',
    customCell: StatusCell,
  },
];

export const StatusTable = ({ rows }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  return (
    <div className={classes.statusTable}>
      <Table
        rowId="EntityCode"
        columns={columns}
        rows={rows}
        defaultRowsPerPage={5}
        rowsPerPageOptions={[5, 10, 15, 'All']}
        emptyProps={{
          text: translateString('No data to display'),
        }}
        tablePaginationProps={{
          labelDisplayedRows: ({ from, to, count }) =>
            `${from}-${to} ${translateString('of')} ${count}`,
          truncate: true,
          labelRowsPerPage: translateString('Rows'),
          pageText: translateString('Page'),
          ofText: translateString('of'),
        }}
      />
    </div>
  );
};
